var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminFileAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32855 6.42622V13.3056C3.33551 13.8086 3.5154 14.2884 3.8294 14.6413C4.14339 14.9942 4.56632 15.1921 5.00691 15.1921C5.4475 15.1921 5.87043 14.9942 6.18443 14.6413C6.49842 14.2884 6.67831 13.8086 6.68527 13.3056L6.69071 4.28852C6.69528 3.85856 6.62506 3.43184 6.48413 3.03309C6.3432 2.63435 6.13436 2.27151 5.86971 1.96562C5.60506 1.65973 5.28987 1.41686 4.94241 1.25111C4.59495 1.08535 4.22213 1 3.84557 1C3.469 1 3.09619 1.08535 2.74873 1.25111C2.40127 1.41686 2.08608 1.65973 1.82143 1.96562C1.55678 2.27151 1.34793 2.63435 1.207 3.03309C1.06607 3.43184 0.99585 3.85856 1.00042 4.28852V13.3663C0.992747 13.9716 1.09053 14.5727 1.28809 15.1344C1.48564 15.6962 1.77903 16.2076 2.15118 16.6387C2.52334 17.0699 2.96684 17.4123 3.45591 17.646C3.94497 17.8797 4.46984 18 5 18C5.53016 18 6.05503 17.8797 6.54409 17.646C7.03316 17.4123 7.47666 17.0699 7.84882 16.6387C8.22097 16.2076 8.51436 15.6962 8.71191 15.1344C8.90947 14.5727 9.00725 13.9716 8.99958 13.3663V4.88344",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminFileAttach);
export default __webpack_public_path__ + "static/media/AdminFileAttach.63508bf79bd0a2295c5824c498733df3.svg";
export { ForwardRef as ReactComponent };